/** @fileoverview Reads the hosted app address from the page hostname when it sits under the apps domain. */

/** Returns the app address when the hostname is exactly one label under the apps domain, else null. */
export const readAppAddress = (hostname: string, appsDomain: string) => {
  const domain = appsDomain.toLowerCase();
  const host = hostname.toLowerCase();
  const suffix = `.${domain}`;
  if (!domain || !host.endsWith(suffix)) {
    return null;
  }
  const label = host.slice(0, -suffix.length);
  return label && !label.includes('.') ? label : null;
};
